import { useEffect, useState } from "react";
import { List } from "antd";
import { useNavigate } from "react-router-dom";
import { AiTwotoneEdit } from "react-icons/ai";
import styles from './NewCLeanersTab.module.css';
import { SearchInput } from "../../../components";
import engineer from "../../../assets/profile2.png";
import engineer2 from "../../../assets/man1.png";
import plusImg from '../../../assets/plusIcon.png';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import CategoriesMiddleware from "../../../store/Middlewares/CategoriesMiddleware";
import { IMG_URL } from "../../../store/Apis";
import dummyImg from '../../../assets/dummy.png';

const NewCLeanersTab = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch()
  const { t, i18n } = useTranslation();
  const CastodialList = useSelector(state => state.CategoriesReducer.CleanerCategoryList)
  const CastodialListPagination = useSelector(state => state.CategoriesReducer.CleanerCategoryPagination)
  const [search, setSearch] = useState('')


  useEffect(() => {
    getNewCleaners();
    getLanguage();
  }, []);

  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language)
    } catch (e) {
      console.log(e)
    }
  };

  const getNewCleaners = () => {

    let data = {
      search: search,
      next_page_url: undefined
    }

    dispatch(CategoriesMiddleware.getSubCategories(data))
  }

  const onPressLoadMore = () => {
    let data = {

      search: search,
      next_page_url: CastodialListPagination?.links?.next
    }
    dispatch(CategoriesMiddleware.getSubCategories(data))
  };

  const loadMore =
    CastodialListPagination?.links?.next ? (
      <div
        style={{
          textAlign: 'center',
          marginTop: 12,
          height: 32,
          lineHeight: '32px',
          display: 'flex', justifyContent: 'center'
        }}
      >
        <button onClick={onPressLoadMore} className={styles.loadMore_button}>
          Load More
        </button>
      </div>
    ) : null;


  const renderItem = (item) => {
    return (
      <div
        className={styles.box_item}

      >
        <div className={styles.left_item} onClick={() =>
          navigate("/Cleaners/NewCleaners/Profile", {
            state: item,
          })
        }>
          <img src={item?.profile_image ? IMG_URL + item?.profile_image : dummyImg} className={styles.image} />
          <div className={styles.heading_view}>
            <text className={styles.tab_heading}> {item?.name}</text>
            <text className={styles.text}>{item?.category_name}</text>
          </div>
        </div>
        <div onClick={() => navigate("/Cleaners/EditCleaner", {
          state: item,
        })}>
          <AiTwotoneEdit size={30} style={{ color: 'var(--secondary-color)' }} />
        </div>
      </div>
    );
  };
  return (
    <>
      <div className={styles.mainCon}>

        <List
          style={{ width: "100%" }}
          grid={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
          dataSource={CastodialList}
          footer={loadMore}
          renderItem={renderItem}
        />

      </div>
      <div className={styles.plusImg}>
        <img onClick={() => navigate("/Cleaners/NewCleaners")} src={plusImg} />
      </div>
    </>
  )
};
export default NewCLeanersTab;